import styled, { css } from 'styled-components'

// styles
import { BREAKPOINTS } from '../../../../styles/constants'

const GRID_GAP_MOBILE = 20 // in px
const VISIBLE_PART_OF_NEXT_RESERVATION_CARD = 20 // in px

export const FutureReservationsGrid = styled.div<{ $breakpoint: keyof typeof BREAKPOINTS }>`
	${({ $breakpoint }) => css`
		display: none;

		@media (min-width: ${BREAKPOINTS[$breakpoint]}) {
			display: grid;
			grid-template-columns: 1fr 1fr;
			gap: 20px;

			@media (min-width: ${BREAKPOINTS.lg}) {
				gap: 40px;
			}
		}
	`}
`

export const ReservationCardWrapper = styled.div<{ $isMoreThenOneReservation: boolean }>`
	flex-shrink: 0;
	scroll-snap-align: center;
	scroll-snap-stop: always;
	width: ${({ $isMoreThenOneReservation }) =>
		$isMoreThenOneReservation ? `calc(100% - ${GRID_GAP_MOBILE}px - ${VISIBLE_PART_OF_NEXT_RESERVATION_CARD}px)` : '100%'};

	@media (min-width: ${BREAKPOINTS.sm}) {
		width: 100%;
	}
`

export const MobileSlider = styled.div<{ $breakpoint: keyof typeof BREAKPOINTS }>`
	${({ $breakpoint }) => css`
		@media (min-width: ${BREAKPOINTS[$breakpoint]}) {
			display: none;
		}
	`}
`
